/**
 * 地区初始化参数设置
 * */
let initAreaResult = (areaList, dataAreaList, zoneTypeAreaMax) => {
  let result = { zoneTypeAreaMax: zoneTypeAreaMax, duplicateRemovalAreaList: [] }
  for (let i = 0, length = dataAreaList.length; i < length; i++) {
    if (areaList.length === 0) {
      result.zoneTypeAreaMax = dataAreaList[i].zoneType
    }
    if (areaList[dataAreaList[i].zoneType - result.zoneTypeAreaMax] === undefined) {
      areaList[dataAreaList[i].zoneType - result.zoneTypeAreaMax] = []
    }
    duplicateRemovalAreaList(result, areaList, dataAreaList[i])
    if (result.duplicateRemovalAreaList[dataAreaList[i].zoneType - result.zoneTypeAreaMax] === undefined) {
      result.duplicateRemovalAreaList[dataAreaList[i].zoneType - result.zoneTypeAreaMax] = []
    }
    result.duplicateRemovalAreaList[dataAreaList[i].zoneType - result.zoneTypeAreaMax].push(dataAreaList[i])
  }
  return result
}

/**
 * 初始化各种list
 * */
let initAllList = (duplicateRemovalAreaList, areaShowList, xAreaShowList, chooseAreaShowList, zoneTypeAreaMax) => {
  areaShowList.splice(0, areaShowList.length)
  xAreaShowList.splice(0, xAreaShowList.length)
  chooseAreaShowList.splice(0, chooseAreaShowList.length)
  for (let i = 0, length = duplicateRemovalAreaList.length; i < length; i++) {
    areaShowList.push(duplicateRemovalAreaList[i])
    xAreaShowList.push(duplicateRemovalAreaList[i])
    chooseAreaShowList.push(duplicateRemovalAreaList[i])
  }
  if (zoneTypeAreaMax === 0) {
    if (xAreaShowList.length > 1) xAreaShowList.splice(2, xAreaShowList.length - 2)
  } else {
    if (xAreaShowList.length > 0) xAreaShowList.splice(1, xAreaShowList.length - 1)
  }
}

/**
 * 显示地区防止重复
 * */
let initAreaShowList = (area, areaList, areaShowList, index) => {
  for (let i = 0, length = areaList[index + 1].length; i < length; i++) {
    if (area.zoneCode12 === areaList[index + 1][i].zoneCode12Parent) {
      if (areaShowList[index + 1] === undefined) {
        areaShowList[index + 1] = []
      }
      duplicateRemovalAreaShowList(areaList[index + 1][i], areaShowList[index + 1])
    }
  }
}

/**
 * 获取选中的地区
 * */
let checkChoose = (dataAreaList, zoneCode12Choose, clearable) => {
  let chooseArea = undefined
  let hasChoose = false
  for (let i = 0, length = dataAreaList.length; i < length; i++) {
    if (dataAreaList[i].zoneCode12 === zoneCode12Choose) {
      chooseArea = dataAreaList[i]
      hasChoose = true
      break
    }
  }
  if (!clearable && !hasChoose && dataAreaList.length > 0) {
    chooseArea = dataAreaList[0]
  }
  return chooseArea
}

/**
 * 判断choose选中状态
 * */
let checkChooseRoute = (msSystem, chooseArea, areaShow) => {
  if (chooseArea === undefined || areaShow.zoneType > chooseArea.zoneType) {
    return false
  }
  return msSystem.subZoneCode12(areaShow.zoneCode12, areaShow.zoneType) === msSystem.subZoneCode12(chooseArea.zoneCode12, areaShow.zoneType)
}

/**
 * 判断mouseover选中状态
 * */
let checkMouseoverRoute = (msSystem, mouseoverArea, areaShow) => {
  if (mouseoverArea === undefined || areaShow.zoneType > mouseoverArea.zoneType) {
    return false
  }
  return msSystem.subZoneCode12(areaShow.zoneCode12, areaShow.zoneType) === msSystem.subZoneCode12(mouseoverArea.zoneCode12, areaShow.zoneType)
}

/**
 * 重置初始化展示pop
 * */
let resetAreaShowList = (chooseArea, areaShowList, chooseAreaShowList, xAreaShowList) => {
  if (chooseArea) {
    areaShowList.splice(0, areaShowList.length)
    for (let i = 0, length = chooseAreaShowList.length; i < length; i++) {
      areaShowList.push(chooseAreaShowList[i])
    }
  } else {
    areaShowList.splice(0, areaShowList.length)
    for (let i = 0, length = xAreaShowList.length; i < length; i++) {
      areaShowList.push(xAreaShowList[i])
    }
  }
}

/**
 * 设置chooseAreaShowList
 * */
let setChooseAreaShowList = (areaShowList, chooseAreaShowList) => {
  chooseAreaShowList.splice(0, chooseAreaShowList.length)
  for (let i = 0, length = areaShowList.length; i < length; i++) {
    chooseAreaShowList.push(areaShowList[i])
  }
}

/**
 * 设置searchAreaShowList
 * */
let setSearchAreaShowList = (dataAreaList, searchAreaShowList) => {
  searchAreaShowList.splice(0, searchAreaShowList.length)
  for (let i = 0, length = dataAreaList.length; i < length; i++) {
    searchAreaShowList.push(dataAreaList[i])
  }
}

export default { initAreaResult, initAllList, initAreaShowList, checkChoose, checkChooseRoute, checkMouseoverRoute, resetAreaShowList, setChooseAreaShowList, setSearchAreaShowList }

let duplicateRemovalAreaList = (result, areaList, dataArea) => {
  let area = areaList[dataArea.zoneType - result.zoneTypeAreaMax]
  for (let i = 0, length = area.length; i < length; i++) {
    if (area[i].rid === dataArea.rid) {
      area[i].loading = dataArea.loading
      return
    }
  }
  area.push(dataArea)
}

let duplicateRemovalAreaShowList = (area, areaShow) => {
  for (let i = 0, length = areaShow.length; i < length; i++) {
    if (areaShow[i].rid === area.rid) {
      areaShow[i].loading = area.loading
      return
    }
  }
  areaShow.push(area)
}
